import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "kpi-picker-layout"
};
const _hoisted_2 = {
  class: "picker-left"
};
const _hoisted_3 = {
  class: "picker-center"
};
const _hoisted_4 = {
  class: "picker-center-header"
};
const _hoisted_5 = {
  class: "header-row"
};
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "header-row"
};
const _hoisted_8 = {
  class: "content",
  style: {
    "min-height": "38px"
  }
};
const _hoisted_9 = {
  class: "picker-center-ctx"
};
const _hoisted_10 = {
  class: "list-body-wrapper"
};
const _hoisted_11 = {
  class: "header-row"
};
const _hoisted_12 = {
  class: "content"
};
import { computed, onMounted, reactive, ref, toRefs } from 'vue';
import { SearchOutlined } from '@ant-design/icons-vue';
import { IndustryTree, useComponentModalInstance } from '@/share/components';
import FilterTags from './filter-tags.vue';
import DepCateList from './dep-cate-list.vue';
import IndustryKpiList from './industry-kpi-list.vue';

import { unref } from 'vue';
export default {
  __name: 'industry-kpi-search-page',
  props: {
    kpiType: {
      type: Number,
      default: 0,
      required: true
    }
  },
  emits: ['select'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const $modal = useComponentModalInstance();
    const props = __props;
    const {
      kpiType
    } = toRefs(props);
    const selectKpiItem = ref();
    const kpiListRef = ref();
    const emit = __emit;
    const selectDepItems = ref([]);
    const selectDepIds = computed(() => {
      return selectDepItems.value.map(t => t.id);
    });
    const selectDepNames = computed(() => {
      return selectDepItems.value.map(t => t.name);
    });
    const selectIndustry = ref({
      id: '',
      name: ''
    });
    const searchKeywords = ref('');
    const queryParams = reactive({
      search: ''
    });
    const handleIndustrySelect = value => {
      selectIndustry.value = value;
    };
    const handleDelSearch = () => {
      queryParams.search = '';
    };
    const handleDelIndustry = () => {
      selectIndustry.value = {
        id: '',
        name: ''
      };
    };
    const handleDelDep = idx => {
      const rows = selectDepItems.value.slice();
      rows.splice(idx, 1);
      selectDepItems.value = rows;
    };
    const handleSearch = () => {
      queryParams.search = searchKeywords.value;
      !!kpiListRef.value && kpiListRef.value.load();
    };
    const handleOpenKpi = row => {};
    const doSelectItem = item => {
      selectKpiItem.value = item;
      if ($modal.isModal()) {
        $modal.confirm(unref(item));
      }
    };
    const handleSelectKpi = item => {
      doSelectItem(item);
      emit('select', item);
    };
    onMounted(() => {
      if ($modal.isModal()) {
        $modal.setModalOptions({
          showConfirmButton: false
        });
      }
    });
    __expose({
      confirmListener() {
        if (selectKpiItem.value) return Promise.resolve(unref(selectKpiItem.value));
        return Promise.resolve(false);
      }
    });
    return (_ctx, _cache) => {
      const _component_vxe_split_pane = _resolveComponent("vxe-split-pane");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_space_compact = _resolveComponent("a-space-compact");
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_split = _resolveComponent("vxe-split");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_vxe_split, {
        height: "100%",
        "action-config": {
          showPrevButton: true
        }
      }, {
        default: _withCtx(() => [_unref(kpiType) + '' === '1' ? (_openBlock(), _createBlock(_component_vxe_split_pane, {
          key: 0,
          width: 200
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(IndustryTree), {
            selected: selectIndustry.value,
            onSelect: handleIndustrySelect
          }, null, 8, ["selected"])])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_vxe_split_pane, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[3] || (_cache[3] = _createElementVNode("span", {
            class: "label"
          }, "指标库", -1)), _createElementVNode("div", _hoisted_6, [_createVNode(_component_a_space_compact, {
            block: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: searchKeywords.value,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => searchKeywords.value = $event),
              placeholder: "指标库标题关键字搜索",
              onKeydown: _withKeys(handleSearch, ["enter"])
            }, null, 8, ["value"]), _createVNode(_component_a_button, {
              onClick: handleSearch
            }, {
              icon: _withCtx(() => [_createVNode(_unref(SearchOutlined))]),
              default: _withCtx(() => [_cache[2] || (_cache[2] = _createTextVNode(" 搜索 ", -1))]),
              _: 1
            })]),
            _: 1
          })])]), _createElementVNode("div", _hoisted_7, [_cache[4] || (_cache[4] = _createElementVNode("span", {
            class: "label"
          }, "筛选", -1)), _createElementVNode("div", _hoisted_8, [_createVNode(FilterTags, {
            "dep-items": selectDepNames.value,
            industry: selectIndustry.value.name,
            search: queryParams.search,
            onDelDep: handleDelDep,
            onDelIndustry: handleDelIndustry,
            onDelSearch: handleDelSearch
          }, null, 8, ["dep-items", "industry", "search"])])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_cache[5] || (_cache[5] = _createElementVNode("span", {
            class: "label"
          }, "部门", -1)), _createElementVNode("div", _hoisted_12, [_createVNode(DepCateList, {
            count: -1,
            "select-items": selectDepItems.value,
            "onUpdate:selectItems": _cache[1] || (_cache[1] = $event => selectDepItems.value = $event)
          }, null, 8, ["select-items"])])]), _createVNode(IndustryKpiList, {
            ref_key: "kpiListRef",
            ref: kpiListRef,
            "kpi-type": _unref(kpiType),
            "industry-id": selectIndustry.value.id,
            "dep-ids": selectDepIds.value,
            "page-size": 50,
            search: queryParams.search,
            onOpen: handleOpenKpi,
            onSelect: handleSelectKpi
          }, {
            itemExtra: _withCtx(({
              item,
              row,
              col
            }) => [_renderSlot(_ctx.$slots, "itemExtra", {
              item: item,
              row: row,
              col: col
            }, () => [_createVNode(_component_vxe_button, {
              status: "primary",
              mode: "text",
              onClick: () => handleSelectKpi(item)
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("选择", -1)]))]),
              _: 1
            }, 8, ["onClick"])])]),
            _: 3
          }, 8, ["kpi-type", "industry-id", "dep-ids", "search"])])])])]),
          _: 3
        })]),
        _: 3
      })]);
    };
  }
};